import { createContext } from 'use-context-selector'
import { OrganizationsContextProps } from './types'

export const OrganizationsContext = createContext(
  {} as OrganizationsContextProps
)
